import axiosInstance from "@/lib/axiosInstance";
import type { RegistryFilesQuery, RegistryFilesResponse } from "./fileRegistry.types";

export const fileRegistryEndpoints = {
  files: "/file-registry/files",
} as const;

export const FileRegistryQueryKeys = {
  files: "file-registry-files",
} as const;

export const getRegistryFiles = async (
  query: RegistryFilesQuery,
): Promise<RegistryFilesResponse["data"]> => {
  const params: Record<string, string | number> = {};
  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") params[key] = value;
  });

  const { data } = await axiosInstance.get<RegistryFilesResponse>(fileRegistryEndpoints.files, {
    params,
  });
  return data.data;
};
